import React, { useMemo } from 'react'
import { TyanEllipsisLabel } from '@sencha/ext-modern'
import _ from 'lodash'

import { getMixedProps } from './blockPublic'
import { useInstData } from 'tyan/public/hooks'

const FormLabel = ({ config: { field, onChange, initValues, changedValues, defaultStyle } }) => {
	const { me } = useInstData(null)

	const { props: { label, style = {}, align, ...props } } = getMixedProps('_label', [defaultStyle, field])
	props.width && delete props.flex

	const compProps = { ...props, style: { /* color: 'rgba(17, 17, 17, 0.54)',  */...style } }
	!_.isEqual(compProps, me.compProps) && (me.compProps = compProps)

	const ret = useMemo(() => {
		return <TyanEllipsisLabel flex={1} html={label} {...align ? { bodyStyle: { textAlign: align } } : {}} {...me.compProps} />
	}, [me.compProps, align, label])
	return ret
}

const renderLabel = config => {
	const { key } = config.field || {}
	return <FormLabel key={key} config={config} />
}

export default renderLabel